/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomEditCard from '../../../../common/components/CustomEditCard/CustomEditCard';
import { fonts, themes } from '../../../../common/themes/themes';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import _ from 'lodash';
import { getAmount } from '../../../../common/configs/utils';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../../common/helper';
import { usePermission } from '../../../../hooks';
interface propsType {
  allPrevAllowancesData: any;
  allPrevAdditionalBenefitsData: any;
  currency: any;
  sortedList: any;
  trans?: any;
}
const SalaryHistoryPresenter: React.FC<propsType> = ({
  currency,
  sortedList,
  trans,
}) => {
  const [cardDrawer, setCardDrawer] = useState(false);

  const userCanShowSalary = usePermission('Employee Portal Show Salary');

  return (
    <>
      <CustomEditCard
        card_title={trans('Salary History')}
        card_height="380px"
        onClick={() => setCardDrawer(!cardDrawer)}
        cardToggle={cardDrawer}
      >
        {userCanShowSalary ? (
          _.map(sortedList, (list: any) => {
            return (
              <CardContentTile
                tile_key={list?.title}
                tile_value={`${currency} ${
                  list?.value
                    ? getAmount(list?.value)
                    : list?.amount
                      ? getAmount(list?.amount)
                      : 0
                }`}
                is_thirdTitle={
                  <span
                    style={{
                      fontSize: fonts.smallSize,
                      fontFamily: fonts.fontFamily,
                      color: themes.tileValue_black,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Valid From') + ' : '}{' '}
                    <DateField
                      value={list?.start_date}
                      format={baseDateFormatting}
                    />
                  </span>
                }
                is_FourthTitle={
                  <span
                    style={{
                      fontSize: fonts.smallSize,
                      fontFamily: fonts.fontFamily,
                      color: themes.tileValue_black,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Updated At')} :
                    <DateField
                      value={list?.updated_at}
                      format={baseDateFormatting}
                    />
                  </span>
                }
              />
            );
          })
        ) : (
          <div
            style={{
              color: 'red',
              padding: '30px',
              borderLeft: '4px solid red',
              fontWeight: 'bold',
              opacity: '0.6',
            }}
          >
            {trans("You Don't have Permission please contact with admin")}
          </div>
        )}
      </CustomEditCard>
    </>
  );
};

export default SalaryHistoryPresenter;
